<template>
  <div class="page-title">
    <h3 class="title-with-icon">
      <component
        v-if="icon"
        :is="`icons-${icon.toLowerCase()}`"
        class="title-icon"
      />
      {{ title }}
    </h3>
  </div>
</template>

<script setup lang="ts">
defineProps({
  title: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    default: '',
  },
})
</script>

<style scoped>
.page-title {
  margin-bottom: 20px;
}

.title-with-icon {
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-icon {
  flex-shrink: 0;
}
</style>
